var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5444_9049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4C3.89688 4 3 4.89688 3 6V17C3 18.1031 3.89688 19 5 19H5.5L6 20H8L8.5 19H15.5L16 20H18L18.5 19H19C20.1031 19 21 18.1031 21 17V6C21 4.89688 20.1031 4 19 4H5ZM10 14C11.3813 14 12.5 12.8813 12.5 11.5C12.5 10.1188 11.3813 9 10 9C8.61875 9 7.5 10.1188 7.5 11.5C7.5 12.8813 8.61875 14 10 14ZM10 16.5C7.2375 16.5 5 14.2625 5 11.5C5 8.7375 7.2375 6.5 10 6.5C12.7625 6.5 15 8.7375 15 11.5C15 14.2625 12.7625 16.5 10 16.5ZM18 10.9156V14.5C18 14.775 17.775 15 17.5 15C17.225 15 17 14.775 17 14.5V10.9156C16.4188 10.7094 16 10.1531 16 9.5C16 8.67188 16.6719 8 17.5 8C18.3281 8 19 8.67188 19 9.5C19 10.1531 18.5813 10.7094 18 10.9156Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5444_9049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white",
    transform: "translate(3 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVault);
export default __webpack_public_path__ + "static/media/icon-vault.b170153343b81863842cf989e96c14f2.svg";
export { ForwardRef as ReactComponent };